import React, { FC } from 'react';

import { Box, Header, Icon, Pressable, Text, VStack } from '@rbilabs/universal-components';

import { useToggleState } from 'hooks/use-toggle-state';
import { primitive, spacing } from 'styles/constants';
const SectionHeader = Pressable.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingY: '$4',
  _web: {
    cursor: 'pointer',
  },
});

const SelectedOption = Header.withConfig({
  variant: 'headerThree',
});

const SelectionOptionsDescription = Text.withConfig({
  variant: 'copyTwo',
  color: primitive.$bbqBrown,
  paddingLeft: '$4',
});

interface IAddExtrasAccordionProps {
  children: React.ReactNode;
  description?: string;
  selection?: string;
  title?: string;
  subtitle?: string;
}

export const AddExtrasAccordion: FC<React.PropsWithChildren<IAddExtrasAccordionProps>> = ({
  children,
  description,
  selection,
  title,
  subtitle,
}) => {
  const [optionsVisible, toggleOptionsVisible] = useToggleState(true);
  const sectionHeaderLabel = `${title}-selection-content-${
    optionsVisible ? 'expanded' : 'collapsed'
  }`;

  return (
    <VStack testID={`selection-${title}`}>
      <SectionHeader
        accessibilityLabel={sectionHeaderLabel}
        onPress={() => toggleOptionsVisible()}
        paddingX={spacing.$1}
      >
        <Box>
          <Header variant="headerThree" marginBottom={0} lineHeight="sm">
            {title}
          </Header>
          {!!subtitle && (
            <Text margin={0} variant="copyTwo" lineHeight={'xs'}>
              {subtitle}
            </Text>
          )}
        </Box>
        <SelectedOption>{selection}</SelectedOption>
        <Icon
          style={{ transform: [{ rotate: !optionsVisible ? '90deg' : '270deg' }] }}
          testID="next-icon"
          variant="next"
        />
      </SectionHeader>
      {optionsVisible && (
        <Box testID={`${title}-selection-content`}>
          {!!description && (
            <SelectionOptionsDescription>{description}</SelectionOptionsDescription>
          )}
          {children}
        </Box>
      )}
    </VStack>
  );
};
